// extracted by mini-css-extract-plugin
module.exports = {"copy":"styles_copy__o3kR1"};